module.exports = __webpack_public_path__ + "img/sync.a1efeec6.png";